(function() {
    'use strict';

    angular.module('app.organizadores', []);
})();
